'use client'

import Reveal from "../../components/ui/Reveal";
import styles from './page.module.css'
import { useState } from "react";



export default function Experience() {
   const [selectedProject, setSelectedProject] = useState(0);

    const selectedProjects = [
        {
            title: "Arsho Laboratories",
            desc: "Fully Operational Nuclear Medicine SPECT-CT Installation.",
            imageUrl: "./images/Haramaya University/arsho.webp"

        },
        {
            title: "Selale University Specialized Hospital",
            desc: "MRI Installation, Oxygen Plant Setup, and Advanced Modular Operating Room.",
            imageUrl: "./images/Selale University/Selale.webp"
        },
        {
            title: "Haramaya University",
            desc: "Hiwot Fana Hospital (MRI Installation and RF Cage Construction).",
            imageUrl: "./images/Haramaya University/hu.webp"
        },
        {
            title: "Ethiopian Airlines Medical Center",
            desc: "MRI Installation and Clinical Applications Support.",
            imageUrl: "./images/Haramaya University/et.webp"
        },
        {
            title: "Negele Arsi General Hospital",
            desc: "CT Scan Installation and Healthcare Infrastructure Support.",
            imageUrl: "./images/ICMC Cath-Lab/negele.webp"
        },
        {
            title: "ICMC Hospital",
            desc: "Cath Lab Installation",
            imageUrl: "./images/ICMC Cath-Lab/ICMC.webp"
        },
        {
            title: "Axon Stroke & Spine Center",
            desc: "Advanced Cardiology Solutions and Installation.",
            imageUrl: "./images/Selale University/axon.webp"
        },
        {
            title: "Kenya Ministry of Health MES Project",
            desc: "Supporting 96 government hospitals and hundreds of imaging systems across Kenya",
            imageUrl: "./images/partner.webp"
        }
    ]
    const stats = [
        { number: "4000+", label: "Installations", icon: "📅" },
        { number: "100+", label: "Turkey Projects", icon: "🏥" },
        { number: "15+", label: "MRI Installations", icon: "🤝" },
        { number: "40+", label: "CT scan installation", icon: "🔧" },
        { number: "5+", label: "Cath Lab Installations", icon: "🤝" }
    ];
    function handleHover(e) {
        //console.log(e.currentTarget)
        console.log(e.currentTarget.id)
        setSelectedProject(parseInt(e.currentTarget.id));
        const target = document.getElementById("projectImg");
        if (target) {
            
           
            //target.src = selectedProjects[parseInt(e.currentTarget.id)].imageUrl;

        }

    }
    function Card({ title, desc, id }) {
        return (
            <div className="item" id={id} onMouseOver={handleHover}>
                <div className={styles.cnt}>
                    <p className={styles.p_title}>{title}</p>
                    <p className={styles.p_desc}>{desc}</p>
                </div>
            </div>
        )
    }
    return (
        <main>
            <section className="pageHero">
                <div className="container" style={{ position: "relative", zIndex: 1 }}>
                    <Reveal>
                        <span className="pageHeroLabel">Expertise</span>
                        <h1 className="pageHeroTitle">Proven Performance Across East Africa</h1>
                        <p className="pageHeroDesc">
                            Infinity has delivered some of the region&apos;s most significant healthcare technology projects.
                        </p>
                    </Reveal>
                </div>
            </section>
            <section className={styles.container}>
                <section className={styles.section}>
                    <h2 className={styles.h2}>Key Achievements</h2>
                    <Reveal direction="right">
                        <div className={styles.statsGrid}>
                            {stats.map((s, i) => (
                                <div key={i} className={styles.statCard}>
                                    {/* <span className={styles.statIcon}>{s.icon}</span> */}
                                    <strong className={styles.statNum}>{s.number}</strong>
                                    <span className={styles.statLabel}>{s.label}</span>
                                </div>
                            ))}
                        </div>
                    </Reveal>

                </section>
                <section className={styles.section}>

                    <h2 className={styles.h2}>Selected Projects</h2>
                    <div className={styles.project_image}>
                        <img id="projectImg"  src={selectedProject !== null ? selectedProjects[selectedProject].imageUrl : ""} alt="" loading="lazy" />
                    </div>

                    <section className={styles.project_section}>
                        {
                            selectedProjects.map((e, idx) => {
                                return (
                                    <Card title={e.title} desc={e.desc} key={idx} id={idx.toString()} />
                                )
                            })
                        }

                    </section>
                </section>
            </section>
        </main>
    )
}